/**
 * Build comments form
 * @param {Object} options - Configuration options
 * @param {number} options.postId - The post ID to comment on
 * @param {string} options.labels.submitButton - Text for the submit button
 * @param {string} options.labels.placeholder - Placeholder text for the textarea
 * @param {Function} options.auth - Auth status
 * @returns {Object} - Form API object
 */

import { modalBase } from "./ModalBase"

export const commentsFormBuilder = (options = {} ) => {

    if(!options.postId) {
        throw new Error("Post id not defined")
    }

    const createHiddenInput = (name, value) => {
        const newInput = document.createElement("input")
        newInput.type = 'hidden'
        newInput.name = name
        newInput.value = value;

        return newInput
    }

    const createTextInput = () => {
        const newInput = document.createElement("textarea")
        newInput.name = "comment"
        newInput.placeholder = options.labels.placeholder
        newInput.classList.add("po-comments-form-fields__input")
        return newInput
    }

    const createDiv = (classList = "") => {
        const newDiv = document.createElement("div")
        if(classList) {
            newDiv.classList.add(classList)
        }

        return newDiv
    }

    const createSubmitButton = () => {
        const newButton = document.createElement("button")
        newButton.type = "submit"
        newButton.innerText = options.labels.submitButton
        newButton.classList.add("po-comments-form-fields__submit")
        newButton.disabled = true;
        return newButton
    }

    const form = document.createElement('form');
    form.classList.add('po-comments-form-fields');
    form.setAttribute('onsubmit', 'return false;');
    form.appendChild(createHiddenInput('comment_post_ID', options.postId))
    form.appendChild(createHiddenInput('comment_parent', options.parentId || "0"))
    form.appendChild(createHiddenInput('comment_author', "0"))

    const input = createTextInput()
    form.appendChild(input)

    const actionsEl = createDiv("po-comments-form-fields__actions")
    const submit = createSubmitButton();
    actionsEl.appendChild(submit)
    const actionsWrapperEl = createDiv("po-comments-form-fields__actions-wrapper")
    actionsWrapperEl.appendChild(actionsEl);
    form.appendChild(actionsWrapperEl)

    input.addEventListener("focus", () => {
        if(!options.auth.isAuthenticated) {
            modalBase(
                'Comments can only be posted by registered users. <a href="/en/login/">Sign</a> in or <a href="/en/register/">register</a> to leave your comment.',
                "When you click one of the links above, a new browser tab will open where you can sign in or register. Once you're signed in, return to this tab and close the popup to leave your comment."
            )
            document.activeElement.blur();
        } else {
            form.classList.add("po-comments-form-fields_focus")
            actionsWrapperEl.classList.add('po-comments-form-fields__actions-wrapper_focus')
        }

    })
    input.addEventListener("blur", () => {
        if(!input.value || input.value.length === 0) {
            form.classList.remove("po-comments-form-fields_focus")
            actionsWrapperEl.classList.remove('po-comments-form-fields__actions-wrapper_focus')
        }
    })
    input.addEventListener("input", () => {

        input.style.height = 'auto';
        input.style.height = (input.scrollHeight - 23) + 'px';

        if(input.value && input.value.length > 0) {
            submit.disabled = false;
        } else {
            submit.disabled = true;
        }
    })

    
    
    const mount = (target) => {
        target.appendChild(form);
    }
    const getComment = () => {
        return input.value
    }
    const clear = () => {
        input.value = ''
    }
    const reset = () => {
        input.value = '';
        submit.disabled = true;
    }

    return {
        form,
        getComment,
        clear,
        reset,
        submitButton: submit,
        mount,
    }
}